var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"color":"blue-grey lighten-1"}},[_c('v-btn',{staticClass:"title white--text green",attrs:{"text":"","small":"","to":"/"}},[_vm._v("Kiuruveden palvelut")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }